export const generateLookupMap = (items, keys, valueKey) => {
  const lookup = {};

  const keysMinusLast = keys.concat();
  const lastKey = keysMinusLast.splice(keysMinusLast.length - 1, 1);

  for (const item of items) {
    let iterator = lookup;

    for (const key of keysMinusLast) {
      if (!iterator[item[key]]) {
        iterator[item[key]] = {};
      }

      iterator = iterator[item[key]];
    }

    iterator[item[lastKey]] = item[valueKey];
  }

  return lookup;
};
